import React, {Component} from 'react';
import {
    Alert
} from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";

import './ChangeEmailFinish.css';

//TODO: add missed translations
class ChangeEmailFinish extends Component {
    componentWillMount() {
        if(this.props.token) {
            this.props.onSubmitEmailChange(this.props.token);
        }
    }

    render() {
        return (
            <div className="change-email-finish">
                {this.renderContent()}
            </div>
        );
    }

    renderContent() {
        let content = null;
        if (!this.props.token) {
            content = <Alert color="danger">{_.get(this.props.translation, 'reset_password.incorrect_link_alert')}</Alert>;
        } else if (this.props.success) {
            content = <h6 className="text-center">{_.get(this.props.translation, 'change_password.finish_change_email')}</h6>;
        } else if (this.props.error) {
            let errorLabel = _.get(this.props.translation, sharedLabelsPath.errors)[this.props.error] || _.get(this.props.translation, sharedLabelsPath.defaultError);
            content = <Alert color="danger">{errorLabel}</Alert>;
        }

        if(_.isNil(content)) {
            return (<h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>);
        }

        return (
            <div>
                <BackButtonComponent path='/login' label={_.get(this.props.translation, 'login.back_to_login_button')}/>
                {content}
            </div>
        )
    }
}

ChangeEmailFinish.propTypes = {
    token: PropTypes.string,
    success: PropTypes.bool,
    error: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onSubmitEmailChange: PropTypes.func.isRequired
};

export default ChangeEmailFinish;



// WEBPACK FOOTER //
// ./src/components/accountManagement/changeEmailFinish/ChangeEmailFinish.js